// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Refer.module.css";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// import { BsWhatsapp } from "react-icons/bs";
// import { BsChevronDown } from 'react-icons/bs';
// import { BsPerson } from 'react-icons/bs';
// import { BsCash } from 'react-icons/bs';

// import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
// import CopyToClipboard from "react-copy-to-clipboard";
// import { FaTelegramPlane } from "react-icons/fa";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);
//   const theme = localStorage.getItem('theme')


//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = JSON.parse(addsetting);

//   const [cardData, setGame] = useState([]);

//   const copyCode = (e) => {
//     navigator.clipboard.writeText(user.referral_code);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   const copyLink = (e) => {
//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referal Link Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   if (user === undefined) {
//     return null;
//   }

//   const referralText = `Hi Friends, Play Box Ludo.in Ludo and earn 10000 daily. Download Indian App Box Ludo.in
//   बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
//    दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

//     NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
//     100% भरोसेमंद प्लेटफार्म । 24 hours support https://Box Ludo.in/login/${user.referral_code}

//     Your ReferralCode is -${user.referral_code}.`


//   // language 


//   const translations = {
//     hi: {
//       referral: 'आपकी रेफरल कमाई',
//       referPerson: 'आमंत्रित किये दोस्त | ',
//       referEarn: 'रेफरल कमाई  ',
//       referCode: 'रेफरल कोड ',
//     },
//     en: {
//       referral: 'Your Referral Earnings',
//       referPerson: 'Referred Players',
//       referEarn: 'Referral Earning',
//       referCode: 'Referral Code',
//     },
//   };

//   // change theme 

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : 'black',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };


//   return (
//     <>
//       {/* <Header user={user} /> */}
//       <div style={styles}>
//         <div
//           className="leftContainer mt-5 pt-5"
//           style={{ ...styles, height: "100%" }}
//         >
//           <section className="referUnique">

//             {/* NEW STYLE INTRO CARD */}
//             <div className="introRibbonCard">
//               <div className="ribbonBar"></div>

//               <div className="ribbonContent">
//                 <img src="/images/refer.png" className="refer_icon" />
//                 <div>
//                   <h3>Refer & Earn</h3>
//                   <p>You can earn more more real money doing refer to your friends</p>
//                 </div>
//               </div>
//             </div>

//             {/* REFERRAL CODE CARD */}
//             <div className="codeLayerCard">
//               <label>Your Referral Code</label>

//               <div className="codeRow">
//                 <strong>{user.referral_code}</strong>

//                 <button className="copySmall" onClick={(e) => copyCode(e)}>
//                   Copy
//                 </button>
//               </div>
//             </div>
//             <div className="whatsapp_share_btn">
//               <a
//                 href={`whatsapp://send?text=Play%20On%20Box Ludo.in%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2FBox Ludo.inludo.com%2Flogin%2F${user.referral_code}`}



//               >
//                 <BsWhatsapp className="icons" />
//                 <span class="ml-2">Whatsapp</span>
//               </a>
//             </div>

//             {/* STATS */}
//             <div className="statsFlex">

//               <div className="statLayerCard">
//                 <div>
//                   <h4>{user.referral_user?.length}</h4>
//                   <p>People Referred</p>
//                 </div>
//                 <img src="/images/trophy.png" className="stat_icon" />
//               </div>

//               <div className="statLayerCard">
//                 <div>
//                   <h4>₹{user.referral_earning}</h4>
//                   <p>Total Earned</p>
//                 </div>
//                 <img src="/images/monney.png" className="stat_icon" />
//               </div>

//             </div>

//           </section>


//         </div>
//       </div>
//     </>
//   );
// };

// export default Refer;


import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import { BsWhatsapp } from "react-icons/bs";
import {
  FiCopy,
  FiUsers,
  FiChevronRight,
  FiGift,
  FiArrowRight,
} from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import "../css/ReferUI.css";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const [copied, setCopied] = useState(false);
  const [sharing, setSharing] = useState(false);

  if (!user) return null;

  const referralCode = user.referral_code || "";
  const totalReferrals = user.referral_user?.length || 0;
  const totalEarnings = user.referral_earning || 0;

  const translations = {
    en: {
      referral: "1 Referral",
      commission: "3% Commission",
      totalReferrals: "Total Referrals",
      totalEarnings: "Total Earnings",
      referralCode: "YOUR UNIQUE REFERRAL CODE",
      copy: "Copy",
      copied: "Copied!",
      invite: "Invite Friends",
      footer1: "More Friends",
      footer2: "More Rewards",
      whatsappTitle: "Invite Friends & Earn",
    },
    hi: {
      referral: "1 Referral",
      commission: "3% Commission",
      totalReferrals: "Total Referrals",
      totalEarnings: "Total Earnings",
      referralCode: "AAPKA UNIQUE REFERRAL CODE",
      copy: "Copy",
      copied: "Copied!",
      invite: "Doston Ko Invite Karein",
      footer1: "More Friends",
      footer2: "More Rewards",
      whatsappTitle: "Invite Friends & Earn",
    },
  };

  const t = translations[language] || translations.en;

  //   const shareText = `🔥 Hello Dost 👋

  // Apni BOX Ludo website par game khelo aur daily paisa jeeto! 💸

  // 🎁 Mere Referral Code se join karo aur 3 % Referral Commission ka fayda pao.

  // 🕹️ Fast Deposit • Fast Withdraw • Exciting Games

  // 👉 Join Now:
  // https://malikludo.com/login/${referralCode}

  // 🎯 Referral Code: ${referralCode} `;

  const shareText = `🎮🔥 आओ दोस्त, BOX LUDO के साथ गेमिंग का मज़ा उठाओ! 🔥🎮

💥 खेलो भी, जीतो भी! 💰

नमस्ते दोस्त 👋❤️

🕹️ अपनी पसंदीदा Ludo गेम खेलो और हर मुकाबले के साथ जीतने का मौका पाओ!

🎁 खास ऑफर तुम्हारे लिए!
मेरे Referral Code से BOX LUDO पर जुड़ो और पाओ 3% Referral Commission का फायदा! 🤩💸

⚡ फास्ट डिपॉजिट
💸 आसान विड्रॉल
🎯 मज़ेदार गेम्स
🏆 शानदार मुकाबले

🚀 अभी जुड़ो और गेमिंग शुरू करो! 👇

🔗 https://boxludo.com/login/${referralCode}

🎁 तुम्हारा Referral Code: ${referralCode}

❤️ अपने दोस्तों के साथ भी शेयर करो और BOX LUDO कम्युनिटी का हिस्सा बनो! 🎉

🔥 BOX LUDO — गेमिंग का नया अंदाज़! 🔥`;

  const copyCode = async () => {
    if (!referralCode) {
      Swal.fire({
        icon: "error",
        title: "Referral code not available",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(referralCode);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = referralCode;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();

        const successful = document.execCommand("copy");
        textArea.remove();

        if (!successful) {
          throw new Error("Copy failed");
        }
      }

      setCopied(true);

      Swal.fire({
        icon: "success",
        title: "Referral Code Copied!",
        text: referralCode,
        showConfirmButton: false,
        timer: 1200,
        toast: true,
        position: "top",
      });

      window.setTimeout(() => {
        setCopied(false);
      }, 1600);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Unable to copy",
        text: "Please copy your referral code manually.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleWhatsApp = () => {
    if (sharing) return;

    setSharing(true);

    const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      shareText
    )}`;

    const openedWindow = window.open(
      whatsappURL,
      "_blank",
      "noopener,noreferrer"
    );

    if (!openedWindow) {
      window.location.href = whatsappURL;
    }

    window.setTimeout(() => {
      setSharing(false);
    }, 1000);
  };

  return (
    <div className="leftContainer box-refer-page">
      <main className="box-refer-main">

        {/* HERO BANNER */}
        <section className="box-refer-hero box-refer-animate">
          <img
            src="/images/refer-rewards.png"
            alt="Invite Friends and Earn Exclusive Rewards"
            className="box-refer-hero-image"
          />

          <span
            className="box-refer-hero-glow"
            aria-hidden="true"
          />

          <span
            className="box-refer-spark box-refer-spark-one"
            aria-hidden="true"
          >
            ✦
          </span>

          <span
            className="box-refer-spark box-refer-spark-two"
            aria-hidden="true"
          >
            ✨
          </span>
        </section>

        {/* REFERRAL STATISTICS */}
        <section
          className="box-refer-stats-card box-refer-animate box-refer-delay-1"
        >
          {/* Referral Commission */}
          <div className="box-refer-stat-row box-refer-stat-first">
            <div className="box-refer-stat-icon box-refer-icon-purple">
              <FiUsers />
            </div>

            <div className="box-refer-stat-info">
              <span>{t.referral}</span>
            </div>

            <div className="box-refer-stat-value box-refer-value-purple">
              {t.commission}
            </div>

            <FiChevronRight className="box-refer-stat-chevron" />
          </div>

          {/* Total Referrals */}
          <div className="box-refer-stat-row">
            <div className="box-refer-stat-icon box-refer-icon-blue">
              <FiUsers />
            </div>

            <div className="box-refer-stat-info">
              <span>{t.totalReferrals}</span>
            </div>

            <div className="box-refer-stat-value box-refer-value-blue">
              {totalReferrals}
            </div>

            <FiChevronRight className="box-refer-stat-chevron" />
          </div>

          {/* Total Earnings */}
          <div className="box-refer-stat-row">
            <div className="box-refer-stat-icon box-refer-icon-green">
              <FiGift />
            </div>

            <div className="box-refer-stat-info">
              <span>{t.totalEarnings}</span>
            </div>

            <div className="box-refer-stat-value box-refer-value-green">
              ₹{Number(totalEarnings).toLocaleString("en-IN")}
            </div>

            <FiChevronRight className="box-refer-stat-chevron" />
          </div>
        </section>

        {/* UNIQUE REFERRAL CODE */}
        <section
          className="box-refer-code-card box-refer-animate box-refer-delay-2"
        >
          <div className="box-refer-code-heading">
            <span className="box-refer-gift-icon">
              <FiGift />
            </span>

            <span>{t.referralCode}</span>
          </div>

          <div className="box-refer-code-content">
            <div className="box-refer-code-box">
              <span>{referralCode || "Not Available"}</span>
            </div>


            <button
              type="button"
              className={`box-refer-copy ${copied ? "box-refer-copied" : ""}`}
              onClick={copyCode}
              disabled={!referralCode}
            >
              <span className="box-refer-copy-icon">
                <FiCopy />
              </span>

              <span className="box-refer-copy-text">
                {copied ? t.copied : t.copy}
              </span>

              <span className="box-refer-copy-shine" />
            </button>

          </div>

          <span
            className="box-refer-code-spark box-refer-code-spark-left"
            aria-hidden="true"
          >
            ✳
          </span>

          <span
            className="box-refer-code-spark box-refer-code-spark-right"
            aria-hidden="true"
          >
            ✳
          </span>
        </section>

        {/* INVITE FRIENDS */}
        <section
          className="box-refer-invite-section box-refer-animate box-refer-delay-3"
        >
          <span
            className="box-refer-invite-decoration box-refer-invite-left"
            aria-hidden="true"
          >
            ✳
          </span>

          <button
            type="button"
            className="box-refer-invite-btn"
            onClick={handleWhatsApp}
            disabled={sharing || !referralCode}
          >
            <BsWhatsapp className="box-refer-whatsapp-icon" />

            <span>{sharing ? "Opening WhatsApp..." : t.invite}</span>

            <FiArrowRight className="box-refer-invite-arrow" />
          </button>

          <span
            className="box-refer-invite-decoration box-refer-invite-right"
            aria-hidden="true"
          >
            ✳
          </span>
        </section>

        {/* FOOTER MESSAGE */}
        <div
          className="box-refer-footer box-refer-animate box-refer-delay-3"
        >
          <div className="box-refer-footer-text">
            <span>{t.footer1}</span>
            <span>{t.footer2}</span>
          </div>

          <span className="box-refer-footer-plane" aria-hidden="true">
            ✈
          </span>
        </div>

      </main>
    </div>
  );
};

export default Refer;
